export function isSuperUserFromJWT(user: any): boolean {
  const permissionString = user['custom:employeePermissions'];
  if (permissionString) {
    const permissions = permissionString.split(':');
    return permissions.includes('READ') && permissions.includes('WRITE');
  }
  return false;
}
